import { CartItemToDeleteType } from '@/features/pos/components/Cart/utils/cart-item-to-delete-id'
import { useGlobalSearchParams } from 'expo-router'

interface CartItemToDelete {
    id: string
    type: CartItemToDeleteType
}

export const useCartItemToDelete = (): CartItemToDelete | undefined => {
    const { cartItemToDeleteId, cartItemToDeleteType } = useGlobalSearchParams<{
        cartItemToDeleteId?: string
        cartItemToDeleteType?: CartItemToDeleteType
    }>()

    if (!cartItemToDeleteId) return undefined

    return {
        id: cartItemToDeleteId,
        type: cartItemToDeleteType === 'container' ? 'container' : 'product',
    }
}
